import React, { FC, useEffect } from 'react'
import { ProductFilterKeys } from '../../../types/product'
import { FilterValue } from '../../../types/storefront'
import { FilterObject } from '../../utils/constants/filters'

interface Props {
  value: FilterValue
  type: ProductFilterKeys
  active: boolean
  onSelect: (type: ProductFilterKeys, value: FilterObject) => any
  onActive?: (active: boolean, value: FilterValue) => any
}

export function formatValue(value: string, type: ProductFilterKeys) {
  let v = value
  if (type === ProductFilterKeys.price) {
    v = v.replace('-', '/')
  }
  if (type === ProductFilterKeys.size) {
    return v.toUpperCase()
  }
  return v.replace('/', '-')
}

const FilterItem: FC<Props> = (props) => {
  const { active, onSelect, value, type, onActive } = props

  useEffect(() => {
    onActive?.(active, value)
  }, [active, value, type])

  return (
    <div
      className="text-tiny font-medium my-2 first:mt-0 cursor-pointer flex items-center"
      key={value.id}
      onClick={() => onSelect(type, { ...value, type } as any)}
    >
      <span
        className={`inline-block w-4 h-4 mr-2 ${active ? 'bg-black' : ''}`}
      />
      <span className={`${active ? 'font-semibold' : ''}`}>
        {formatValue(value.label, type)}
      </span>
    </div>
  )
}

export default FilterItem
